"use strict";

module.exports = {
	List: require('./Users'),
	View: require('./UserDetails'),
	AddEdit: require('./UserAddEdit')
};